import styled from 'styled-components';
import {
  colorBlack900,
  colorGrey100,
  colorSecondary,
  fontFamilySecondary,
  mediaQueryLaptopMin,
  mediaQueryMobileMin,
} from 'styles';

export const Wrapper = styled.div`
  padding: 16px;
  margin: 16px 0 0;
  border-top: 2px solid #d30000;
  width: 100%;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.16);
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: ${fontFamilySecondary};

  @media ${mediaQueryMobileMin} {
    flex-direction: row;
  }

  @media ${mediaQueryLaptopMin} {
    display: block;
    margin-top: 0;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  @media ${mediaQueryMobileMin} {
    width: 75%;
  }

  @media ${mediaQueryLaptopMin} {
    width: 100%;
  }
`;

export const Title = styled.p`
  font-weight: 700;
  font-size: 13px;
  line-height: 18px;
  color: ${colorBlack900};
`;

export const IconWrapper = styled.div`
  margin-right: 8px;
`;

export const Button = styled.a`
  display: block;
  width: 100%;
  margin-top: 12px;
  padding: 12px;
  text-align: center;
  background: ${colorSecondary};
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  appearance: none;
  border-radius: 2px;

  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.9;
  }

  @media ${mediaQueryMobileMin} {
    width: 104px;
    margin-top: 0;
  }

  @media ${mediaQueryLaptopMin} {
    margin-top: 12px;
    width: 100%;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px;
  border: 1px solid ${colorGrey100};
  border-radius: 8px;
  font-family: ${fontFamilySecondary};

  @media ${mediaQueryMobileMin} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 16px;
`;

export const ContentIconWrapper = styled.div`
  flex-shrink: 0;
`;

export const ContentTitle = styled.p`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${colorBlack900};
`;

export const ContentButton = styled.a`
  display: block;
  width: 100%;
  padding: 8px 16px;
  text-align: center;
  background: ${colorSecondary};
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  appearance: none;
  border-radius: 2px;

  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.9;
  }

  @media ${mediaQueryMobileMin} {
    width: 104px;
    flex-shrink: 0;
  }
`;
